import { createTheme } from '@mantine/core';

export default (
  createTheme({
    primaryShade: 6,
    autoContrast: true,
    primaryColor: 'simplevoip',
    colors: {
      simplevoip: [
        '#fff5e1', '#ffeacc', '#ffd39a', '#ffbb64', '#ffa737',
        '#ff9a1b', '#fe8f00', '#e38000', '#cb7100', '#b06000',
      ],
    },
  })
);
